import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

import Autocomplete from "@mui/material/Autocomplete";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers/";
import dayjs from "dayjs";
import "dayjs/locale/ro";
dayjs.locale("ro");

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function EditDialog({
  open,
  onClose,
  edited,
  onSave,
  onEditChange,
  serviceOpt,
  statusOpt,
  doctorOpt,
}) {
  // console.log("edited", edited);
  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md"
        fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
          Editeaza Programare
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                id="id"
                label="ID Programare"
                fullWidth
                disabled={true}
                value={edited ? edited._id : ""}
                variant="standard"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                id="id"
                disabled={true}
                label="Adaugata in"
                fullWidth
                value={
                  edited
                    ? dayjs(edited?.createdAt).format("DD MMMM YYYY HH:mm")
                    : ""
                }
                variant="standard"
              />
            </Grid>
          </Grid>
          <Typography sx={{ my: 3 }}> </Typography>
          {/* <Typography sx={{ mt: 3 }}> Detalii Provider</Typography> */}
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                name="service_type"
                id="id"
                select
                label="Service"
                fullWidth
                onChange={onEditChange}
                value={edited ? edited.service_type : ""}
                // variant="standard"
              >
                {serviceOpt.map((opt) => (
                  <MenuItem key={opt.id} value={opt.id}>
                    {opt.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={4}>
              <Autocomplete
                disablePortal
                value={edited ? edited.doctor : ""}
                id="doctor"
                name="doctor"
                options={doctorOpt}
                isOptionEqualToValue={(option, value) =>
                  option._id === value._id
                }
                getOptionLabel={(option) => option.name || ""}
                onChange={(event, newValues) => {
                  console.log(event, newValues);
                  onEditChange({
                    target: { name: "doctor", value: newValues },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Doctor"
                    margin="dense"
                    name="doctor"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="status"
                name="status"
                select
                label="Status"
                fullWidth
                onChange={onEditChange}
                value={edited ? edited.status : ""}
                // variant="standard"
              >
                {statusOpt.map((status) => (
                  <MenuItem key={status.id} value={status.id}>
                    {status.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={4}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="ro"
              >
                <DatePicker
                  label="Data Programarii"
                  name="date"
                  value={edited ? edited.start_time : ""}
                  onChange={(newValue) => {
                    onEditChange({
                      target: { name: "start_time", value: newValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} margin="dense" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={4}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="ro"
              >
                <TimePicker
                  label="Start"
                  name="start"
                  value={edited ? edited.start_time : ""}
                  onChange={(newValue) => {
                    onEditChange({
                      target: { name: "start_time", value: newValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} margin="dense" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="ro"
              >
                <TimePicker
                  label="End"
                  name="end"
                  value={edited ? edited.end_time : ""}
                  onChange={(newValue) => {
                    onEditChange({
                      target: { name: "end_time", value: newValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} margin="dense" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Typography sx={{ my: 3 }}> Detalii Pacient</Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                name="p_name"
                label="Nume Pacient"
                fullWidth
                onChange={onEditChange}
                value={edited ? edited.p_name : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                name="p_phone"
                label="Telefon Pacient"
                fullWidth
                onChange={onEditChange}
                value={edited ? edited.p_phone : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                name="p_email"
                label="Email Pacient"
                fullWidth
                onChange={onEditChange}
                value={edited ? edited.p_email : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                multiline
                rows={3}
                id="id"
                name="notes"
                label="Notite"
                fullWidth
                onChange={onEditChange}
                value={edited ? edited.notes : ""}
                // variant="standard"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={() => onSave(edited)}>Save Appointment</Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
